import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
  state: {
    userList: [],
  },
  mutations: {},
  actions: {
    async getDepartmentBannerList(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getDepartmentBannerList`, data)

          if (!result.data.errorCode || result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async getDepartmentBannerDetail(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/getDepartmentBannerDetail`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async createDepartmentBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/createDepartmentBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    async updateDepartmentBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/updateDepartmentBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
    async deleteDepartmentBanner(context, data) {
      return new Promise(async (resolve, reject) => {
        try {
          let result = await axios.post(`${config.domain}/deleteDepartmentBanner`, data)

          if (result.data.errorCode === 0) {
            resolve(result)
          } else {
            context.commit("setwarning", {
              string: result.data.errorMessage,
              boolean: true,
              button: [{
                name: "Cancel",
                callBack: function () {}
              }]
            })
            resolve(false)
          }
        } catch (err) {

          reject(err)
        }
      })
    },
  },
  getters: {}
}

export default moduleStore;